var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProposalDetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.2186 7.8125H14.3228C13.8915 7.8125 13.5415 8.1625 13.5415 8.59375C13.5415 9.025 13.8915 9.375 14.3228 9.375H24.2186C24.6498 9.375 24.9998 9.025 24.9998 8.59375C24.9998 8.1625 24.6498 7.8125 24.2186 7.8125Z",
    fill: "#4B4B4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2186 10.9375H14.3228C13.8915 10.9375 13.5415 11.2875 13.5415 11.7188C13.5415 12.15 13.8915 12.5 14.3228 12.5H24.2186C24.6498 12.5 24.9998 12.15 24.9998 11.7188C24.9998 11.2875 24.6498 10.9375 24.2186 10.9375Z",
    fill: "#4B4B4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2186 14.0625H14.3228C13.8915 14.0625 13.5415 14.4125 13.5415 14.8437C13.5415 15.275 13.8915 15.625 14.3228 15.625H24.2186C24.6498 15.625 24.9998 15.275 24.9998 14.8437C24.9998 14.4125 24.6498 14.0625 24.2186 14.0625Z",
    fill: "#4B4B4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2186 17.1875H14.3228C13.8915 17.1875 13.5415 17.5375 13.5415 17.9687C13.5415 18.4 13.8915 18.75 14.3228 18.75H24.2186C24.6498 18.75 24.9998 18.4 24.9998 17.9687C24.9998 17.5375 24.6498 17.1875 24.2186 17.1875Z",
    fill: "#4B4B4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2186 20.3124H14.3228C13.8915 20.3124 13.5415 20.6624 13.5415 21.0937C13.5415 21.5249 13.8915 21.8749 14.3228 21.8749H24.2186C24.6498 21.8749 24.9998 21.5249 24.9998 21.0937C24.9998 20.6624 24.6498 20.3124 24.2186 20.3124Z",
    fill: "#4B4B4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.82292 25H9.63542C10.6406 25 11.4583 24.1823 11.4583 23.1771V9.63542C11.4583 8.63021 10.6406 7.8125 9.63542 7.8125H1.82292C0.817708 7.8125 0 8.63021 0 9.63542V23.1771C0 24.1823 0.817708 25 1.82292 25Z",
    fill: "#4B4B4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2186 23.4374H14.3228C13.8915 23.4374 13.5415 23.7874 13.5415 24.2187C13.5415 24.6499 13.8915 25 14.3228 25H24.2186C24.6498 25 24.9998 24.6499 24.9998 24.2187C24.9998 23.7874 24.6498 23.4374 24.2186 23.4374Z",
    fill: "#4B4B4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.177 0H10.1562C9.15096 0 8.33325 0.817708 8.33325 1.82292V4.42708C8.33325 5.43229 9.15096 6.25 10.1562 6.25H23.177C24.1822 6.25 24.9999 5.43229 24.9999 4.42708V1.82292C24.9999 0.817708 24.1822 0 23.177 0Z",
    fill: "#4B4B4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.125 6.25C4.85089 6.25 6.25 4.85089 6.25 3.125C6.25 1.39911 4.85089 0 3.125 0C1.39911 0 0 1.39911 0 3.125C0 4.85089 1.39911 6.25 3.125 6.25Z",
    fill: "#4B4B4B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProposalDetails);
export default __webpack_public_path__ + "static/media/ProposalDetails.e20580c8.svg";
export { ForwardRef as ReactComponent };